<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader hero>
      <TextHeading variant="subtitle" color="secondary">Knowing our customers</TextHeading>
      <TextHeading variant="xl" block>Health &amp; Nutrition</TextHeading>
    </PageHeader>
    <SubMenuMobile/>
    <PageGrid sidebar sharetools>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <ShareLinksArticle desktop></ShareLinksArticle>
        <HeroImage image="cr-fishing-health.jpg"></HeroImage>
        <TextProse>
          <p>Food from the sea has incredible nutritional benefits and, in the UK, most of us don’t eat enough of it. From heart healthy fats and protein, to a wealth of essential vitamins and minerals, there are so many reasons to up your intake of fish and seafood.</p>
          <p>A large number of the species that we stock are sourced from the productive mixed species fishery in the South West of England which includes scallops, sprats, gurnard, pouting and four species of ray.</p>
        </TextProse>
        <CardFeature v-for="item in items" v-bind:data="item" v-bind:key="item.id"></CardFeature>
        <ShareLinksArticle mobile></ShareLinksArticle>
      </PageMain>
    </PageGrid>
    <FooterInfo></FooterInfo>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import FooterInfo from '../components/FooterInfo.vue'
import TextProse from '../elements/TextProse.vue'
import PageMain from '../elements/PageMain.vue'
import HeroImage from '../components/HeroImage.vue'
import ShareLinksArticle from '../components/ShareLinksArticle.vue'
import CardDownload from '../components/CardDownload.vue'
import CardFeature from '../components/CardFeature.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import SubMenuMobile from '../components/SubMenuMobile.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'

export default {
  name: 'SeafoodHealthNutrition',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    SubMenuMobile,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    CardDownload,
    CardFeature,
    ShareLinksArticle,
    HeroImage,
    PageMain,
    TextProse,
    FooterInfo,
    TheFooter
  },
  data() {
    return {
      items: [
        {
          image: require('@/assets/images/cr-fishing-mackerel.png'),
          header: 'Omega 3',
          text:
            'Perhaps one of the best known benefits are the so-called ‘heart healthy’ omega 3 fats found in oily fish such as salmon, mackerel, trout and sardines, as well as crab and mussels. It’s recommended that we eat one portion (around 140g) of these each week and the good news is that if cooking isn’t your thing, tinned fish counts too!',
          subtitle: 'Great tip',
          feature:
            'Instead of your usual tuna sandwich, try blending tinned mackerel with cream cheese and a squeeze of lemon for a quick and easy mackerel pâté, or serve tinned salmon with a little mayonnaise and sliced cucumber. Tinned fish also make quick and easy fishcakes, great with a green salad for a light and tasty lunch or supper.'
        },
        {
          image: require('@/assets/images/cr-fishing-prawns.png'),
          header: 'High in protein and low in fat',
          text:
            'White fish, such as cod, haddock, coley, pollock and plaice are high in protein, which helps to build and maintain muscles, and low in fat, so they’re a great option if you’re watching your weight.',
          subtitle: 'Great tip',
          feature:
            'Prawns, too, are high in protein and low in fat, especially saturated fat. We now know that the cholesterol they contain doesn’t have a significant impact on our cholesterol levels. Rather, cutting saturated fat intake helps keep blood cholesterol levels normal, making prawns a good choice.'
        }
      ]
    }
  }
}
</script>
